var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.165 1.42188H6.83582C6.09915 1.42188 5.49707 2.01688 5.49707 2.75354V3.41938C5.49707 4.15604 6.09207 4.75104 6.82874 4.75104H10.165C10.9017 4.75104 11.4967 4.15604 11.4967 3.41938V2.75354C11.5037 2.01688 10.9017 1.42188 10.165 1.42188Z",
    fill: "#3C3F42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2113 3.41299C12.2113 4.53924 11.2905 5.46008 10.1642 5.46008H6.83508C5.70883 5.46008 4.78799 4.53924 4.78799 3.41299C4.78799 3.01633 4.36299 2.76841 4.00883 2.95258C3.01008 3.48383 2.33008 4.53924 2.33008 5.75049V12.4159C2.33008 14.1584 3.75383 15.5822 5.49633 15.5822H11.503C13.2455 15.5822 14.6692 14.1584 14.6692 12.4159V5.75049C14.6692 4.53924 13.9892 3.48383 12.9905 2.95258C12.6363 2.76841 12.2113 3.01633 12.2113 3.41299ZM8.76883 12.0051H5.66633C5.37591 12.0051 5.13508 11.7642 5.13508 11.4738C5.13508 11.1834 5.37591 10.9426 5.66633 10.9426H8.76883C9.05924 10.9426 9.30008 11.1834 9.30008 11.4738C9.30008 11.7642 9.05924 12.0051 8.76883 12.0051ZM10.6247 9.17174H5.66633C5.37591 9.17174 5.13508 8.93091 5.13508 8.64049C5.13508 8.35008 5.37591 8.10924 5.66633 8.10924H10.6247C10.9151 8.10924 11.1559 8.35008 11.1559 8.64049C11.1559 8.93091 10.9151 9.17174 10.6247 9.17174Z",
    fill: "#3C3F42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/templateIcon.042d5d4dfad7d52c69406b9ed73e82fb.svg";
export { ForwardRef as ReactComponent };